import React, { useEffect } from "react";
import { Alert } from "@material-ui/lab";
import { Typography } from "@material-ui/core";
import { useMainState } from "modules/app/contexts";
import { Container } from "./styles";
import { useHistory } from "react-router-dom";
import { UserForm } from "modules/app/components/UserForm";

function UsersNew() {
  const { company, user } = useMainState();
  const history = useHistory();

  useEffect(() => {
    if (user?.role == "seller") {
      history.push("/app");
    }
  }, [user]);

  const userForm = {
    name: "",
    email: "",
    phone1: "",
    signature: "",
    receive_lead: true,
    role: "seller",
    company_team_ids: [
      company?.company_teams?.length > 0 && company.company_teams[0]?.id,
    ],
    status: "active",
    external_id: { id: null },
    password: null,
    passwordConfirmation: null,
  };

  return (
    <Container>
      <Typography style={{ fontWeight: "bold", fontSize: 22 }}>
        Criar novo usuário
      </Typography>

      <UserForm userForm={userForm} />
    </Container>
  );
}

export default UsersNew;
